import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaIdCard, FaCarSide, FaUser } from 'react-icons/fa';
import classNames from 'classnames/bind';
import styles from './VehicleDetail.module.css';

// Import ảnh trong thư mục assets
import checkinImg from '~/assets/logo.jpg';
import washImg from '~/assets/huk.png';

const cx = classNames.bind(styles);

// Mock data
const vehicle = {
  id: '1',
  plate: '19L-24244',
  driver: 'Nguyen Van A',
  car: 'VF6',
  reports: [
    {
      id: 1,
      type: 'check-in',
      date: '2025-08-20 14:30',
      image: checkinImg,
    },
    {
      id: 2,
      type: 'wash',
      date: '2025-08-19 09:15',
      image: washImg,
    },
  ],
};

const VehicleDetailPage = () => {
  const { vehicleId } = useParams();
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);

  const openImageModal = (image) => setSelectedImage(image);
  const closeImageModal = () => setSelectedImage(null);

  return (
    <div className={cx('vehicleContainer')}>
      {/* Header */}
      <header className={cx('header')}>
        <button
          onClick={() => navigate(-1)}
          className={cx('backButton')}
          aria-label="Go back"
        >
          <FaArrowLeft size={20} />
        </button>
        <h2 className={cx('headerTitle')}>Lịch sử giao dịch</h2>
      </header>

      {/* Thông tin xe */}
      <section className={cx('vehicleInfo')}>
        <h3 className={cx('infoTitle')}>Thông Tin Xe</h3>
        <div className={cx('vehicleCard')}>
          <div className={cx('vehicleRow')}>
            <FaCarSide className={cx('vicon')} />
            <span><strong>Xe:</strong> {vehicle.car}</span>
          </div>
          <div className={cx('vehicleRow')}>
            <FaIdCard className={cx('vicon')} />
            <span><strong>Biển số:</strong> {vehicle.plate}</span>
          </div>
          <div className={cx('vehicleRow')}>
            <FaUser className={cx('vicon')} />
            <span><strong>Lái xe:</strong> {vehicle.driver}</span>
          </div>
        </div>
      </section>

      {/* Danh sách lịch sử báo cáo */}
      <div className={cx('historyContainer')}>
        <div className={cx('reportList')}>
          {vehicle.reports.map((report) => (
            <div key={report.id} className={cx('reportCard')}>
              <h4 className={cx('reportType')}>
                {report.type === 'check-in' ? 'Check-in' : 'Rửa xe'}:
              </h4>
              <div className={cx('reportDetails')}>
                <p className={cx('reportDate')}>Thời gian: {report.date}</p>
                <img
                  src={report.image}
                  alt={report.type}
                  className={cx('reportImage')}
                  onClick={() => openImageModal(report.image)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className={cx('modal')}>
          <div className={cx('modalContent')}>
            <img
              src={selectedImage}
              alt="Full view"
              className={cx('modalImage')}
            />
            <button
              onClick={closeImageModal}
              className={cx('modalCloseButton')}
              aria-label="Close modal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={cx('closeIcon')}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VehicleDetailPage;
